import type { StoreApi } from 'zustand';
import React, { PropsWithChildren, useContext, useEffect, useState } from 'react';
import { createContext, useRef } from 'react';
import { createStore, useStore } from 'zustand';
import { CryptoTradingStoreType, StoreCreator } from './store';
const CryptoTradingStoreContext = createContext<any>(null);
export const CryptoTradingProvider: React.FC<PropsWithChildren> = ({
  children
}) => {
  const storeRef = useRef<StoreApi<CryptoTradingStoreType>>();
  const [inited, setInited] = useState<boolean>(false);
  useEffect(() => {
    if (!storeRef.current) {
      storeRef.current = createStore(StoreCreator);
    }
    setInited(true);
  }, []);
  return inited ? <CryptoTradingStoreContext.Provider value={storeRef.current}>
      {children}
    </CryptoTradingStoreContext.Provider> : null;
};
type Selector = (state: unknown) => any;
export const useCryptoTradingContext = (selector: Selector = state => state) => {
  const store = useContext(CryptoTradingStoreContext);
  if (!store) {
    throw new Error('Missing StoreProvider');
  }
  return useStore(store, selector);
};